export default __webpack_public_path__ + "static/media/hero-video-safari-es.5eda9010.mp4";